import { useEffect } from 'react';

/*
 * Запертая страница под открытым слоем на телефоне. Хостов стопки может
 * быть несколько разом (раздел внутри раздела), поэтому замок считается:
 * класс nav-locked стоит на <html>, пока хоть один хост держит его.
 *
 * Вместе с замком включается слежение за visualViewport: экранная
 * клавиатура не уменьшает страницу, а накрывает низ и сдвигает её; высота
 * видимой области отдаётся в --vv-h, любой сдвиг возвращается на ноль.
 */

let holders = 0;
let release: (() => void) | null = null;

function acquire() {
  holders++;
  if (holders > 1) return;
  const root = document.documentElement;
  root.classList.add('nav-locked');
  const vv = window.visualViewport;
  const apply = () => {
    if (vv) root.style.setProperty('--vv-h', `${Math.round(vv.height)}px`);
    if (window.scrollY || (vv && vv.offsetTop)) window.scrollTo(0, 0);
  };
  apply();
  vv?.addEventListener('resize', apply);
  vv?.addEventListener('scroll', apply);
  window.addEventListener('scroll', apply);
  release = () => {
    vv?.removeEventListener('resize', apply);
    vv?.removeEventListener('scroll', apply);
    window.removeEventListener('scroll', apply);
    root.style.removeProperty('--vv-h');
    root.classList.remove('nav-locked');
  };
}

function free() {
  holders = Math.max(0, holders - 1);
  if (holders === 0 && release) {
    release();
    release = null;
  }
}

/** Держать замок, пока `on`. */
export function useNavLock(on: boolean) {
  useEffect(() => {
    if (!on) return;
    acquire();
    return free;
  }, [on]);
}
